import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import * as moment from 'moment';

import { User } from './shared/models/user/user.model';
import { Company } from './shared/models/company/company.model';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: [ './app.component.scss' ]
})
export class AppComponent {
    constructor(
        private translate: TranslateService,
        private router: Router
    ) {
        translate.addLangs([ 'en', 'fr', 'ur', 'es', 'it', 'fa' ])
        translate.setDefaultLang('en')
        const browserLang = translate.getBrowserLang()
        translate.use(browserLang.match(/en|fr|ur|es|it|fa/) ? browserLang : 'en')
    }
}
